// @flow

// $FlowFixMe : SHOULDNOTHAPPEN
const API_ROOT: string = process.env.REACT_APP_API_ROOT;

export type JsonDatetime = string | number;

export type OrderRequest = {
  name: string,
  email: string,
  tel: string,
  items: { [id: string]: number }
};

export async function createOrder(
  orderRequest: OrderRequest
): Promise<boolean> {
  const req = await fetch(`${API_ROOT}/orders`, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    },
    method: "POST",
    body: JSON.stringify(orderRequest)
  });

  return req.ok;
}



// WEBPACK FOOTER //
// ./src/api/orders.js